<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zyu10m/tc-custom/9781452127286.jpg?1700253328470" alt="This image is the cover for the book But I Wanted a Pony!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">But I Wanted a Pony!
      </h1>
      <p class="bookDescription body article font2">
        <b>This collection of vintage-with-a-twist artwork offers a fresh serving of hilarious commentary on the joys, challenges, and cocktail hours of motherhood. </b><br/>  <br/> From the fundamentals (WOW! I get to give birth AND change diapers!) to putting food on the table (you see them as pies . . . I see them as cries for help) to dealing with childhood questions (because I’m the mother . . . that’s why) and strategies for taking the edge off (now be a dear and fetch mommy her flask), Taintor expertly captures the funny, frantic, and honest thoughts that most moms have experienced, with an attitude mothers everywhere will welcome. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anne Taintor
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?64cdcbf5